var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1588 8.74025H14.2213V6.2495C14.1852 5.94424 14.2867 5.63874 14.4982 5.41574C14.7098 5.19274 15.0095 5.07531 15.3163 5.09525H18.0913V0.98375L14.2663 0.96875C10.0213 0.96875 9.06126 4.03625 9.06126 5.999V8.74025H6.60126V12.977H9.06126V24.9688H14.2213V12.977H17.7088L18.1588 8.74025Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fb.0e7e88c98ca07483311ff355694e1e6a.svg";